import React, { useState } from "react";
import "../../App.scss";
import RightBar from "../../layouts/Dashboard/components/rightbar";
import { OrdersTable } from "../all-orders/components";
import AllOrderDetailsRightBar from "../all-orders/components/rightsidebar/rightsidebar_details";
import { OrderDetailsData } from "../../contexts";
import { ALL_ORDER_TYPE } from "../../utils/constants";

function FutureOrders() {
    const [OrderType, setOrderType] = useState(ALL_ORDER_TYPE);
    const [data, setData] = useState();
    const [rightBarOpen, setRightBarOpen] = useState({
        name: "all-orders",
        open: false,
    });

    // const { openModal } = useModalMain()

    const changeRightBarOpen = () => {
        if (!rightBarOpen.open) {
            setRightBarOpen({
                ...rightBarOpen,
                open: true,
            });
        }
    };
    const changeRightBarClose = () => {
        setRightBarOpen({
            ...rightBarOpen,
            open: false,
        });
    };

    return (
        <div className="p-7 h-full overflow-y-scroll bg-gray-50">
            <RightBar
                rightBarOpenAction={changeRightBarOpen}
                rightBarCloseAction={changeRightBarClose}
                value={rightBarOpen.open}
                data={data}>
                <AllOrderDetailsRightBar {...data} />
            </RightBar>
            {/* <div className="flex justify-between items-center mb-1"> */}
            {/* <button className="bg-elm-500 text-white-100 hover:bg-elm-700 font-semibold py-2 rounded-2xl" style={btnstyles} onClick={()=>openModal(OrderForm)}>Gererate Invoice</button> */}
            {/* </div> */}
            <OrderDetailsData.Provider value={{ data, setData, OrderType, setOrderType, isReorder: true }}>
                <OrdersTable changeRightBarOpen={changeRightBarOpen} />
            </OrderDetailsData.Provider>
        </div >
    );
}

export { FutureOrders };

